module.exports = __webpack_public_path__ + "static/media/news3.08b8e58b.jpg";